import React from 'react';
import { Outlet } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { FavoritesProvider } from './context/FavoritesContext';
import { ClienteAuthProvider } from './context/ClienteAuthContext';
import EcommerceNavbar from './components/EcommerceNavbar';
import EcommerceFooter from './components/EcommerceFooter';
import CartSidebar from './components/CartSidebar';
import './ecommerce.css';

const EcommerceLayout = () => {
    return (
        <ClienteAuthProvider>
            <CartProvider>
                <FavoritesProvider>
                    <div className="ec-app">
                        <EcommerceNavbar />
                        <main>
                            <Outlet />
                        </main>
                        <EcommerceFooter />
                        <CartSidebar />
                    </div>
                </FavoritesProvider>
            </CartProvider>
        </ClienteAuthProvider>
    );
};

export default EcommerceLayout;
